import { NotFoundPageV2 } from "../../../ui/pages/v2/NotFoundPage";

export function NotFoundV2Route() {
  return <NotFoundPageV2 />;
}
